import Utils, { Colors, LevelRange } from "@/components/shared/util";
import { navigationNamespace } from "@/store/modules/navigation";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

export interface RiskItem {
  label: string;
  level: LevelRange;
}

@Component({})
export default class RiskList extends Vue {
  @Prop(Array)
  items!: Array<RiskItem>;

  @Prop(Boolean)
  useRedBullets!: boolean;

  @Prop(Boolean)
  hasLevel!: boolean;

  @Prop(Boolean)
  showAll!: boolean;

  hideEmpty = false;

  mounted() {
    if (!this.showAll && (this.hasLevel || this.isMobile)) {
      this.hideEmpty = true;
    }
  }

  @Getter("isMobile", navigationNamespace)
  isMobile!: boolean;

  bullet(level: LevelRange) {
    let color = Utils.getLevelColor(level, false);
    // Convert 1 & 5 from red to orange for risk bulllets
    if (color === Colors.Red && !this.useRedBullets) {
      color = Colors.Orange;
    }
    return {
      color: color,
      icon: Utils.getLevelIcon(level)
    };
  }
}
